import { FC, type JSX, useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '@/store/hooks/redux';
import { AvailablePlatformsEnum } from '../../../../constants/available-platforms';
import CreativeTypesEnum from '../../../../constants/creatives-types.enum';
import { IPlatformCreativeFormResolverProps } from '../models/form-resolver-props.interface';
import GoogleCreativeForm from '@/editor/shared/components/forms/creatives/google/GoogleForm';
import { ISingleCreativeFormValuesModel } from '@/editor/shared/components/forms/creatives/models/single-creative-form-values.model';
import Grid from '@mui/material/Grid';
import { setMediaLibraryDrawerState } from '@/editor/store/reducers/modals-drawers.slice';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';
import { setKeyValuePairToLS } from '@/shared/services/localstorage';
import useRestoreState from '@/editor/pages/create-ads-steps-page/components/creatives-step/hooks/useRestoreState';
import { GooglePreviewContainer } from './GooglePreviewContainer';
import Card from '@mui/material/Card';
import CommonButton from '@/shared/components/CommonButton';
import SendOutlined from '@mui/icons-material/SendOutlined';
import { useTranslation } from 'react-i18next';
import { setcreativeSubmissionProgress } from '@/editor/store/reducers/creative-step.slice';

export const GoogleFormsResolver: FC<IPlatformCreativeFormResolverProps> = ({
  creativeType,
  updating,
}): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const initialValuesFromStore = useAppSelector((state) => state.creativeStepSliceReducer.creativeFormsState);
  const selectedCreativeType = useAppSelector((state) => state.creativeStepSliceReducer.selectedCreativeType);
  const isFormInitialized = useAppSelector((state) => state.creativeStepSliceReducer.isInitialized);

  const creativeFormValues = useRestoreState(AvailablePlatformsEnum.GOOGLE_ADS, isFormInitialized);

  const handleUpdate = () => {
    dispatch(
      setcreativeSubmissionProgress({ active: true, update: true, platform: AvailablePlatformsEnum.GOOGLE_ADS })
    );
  };

  const handleMediaLibraryOpen = useCallback(() => {
    dispatch(
      setMediaLibraryDrawerState({
        isOpened: true,
        creativeType: selectedCreativeType,
        platform: AvailablePlatformsEnum.GOOGLE_ADS,
      })
    );
  }, [dispatch, selectedCreativeType]);

  const handleFormValuesChange = useCallback(
    (values: ISingleCreativeFormValuesModel) => {
      if (isFormInitialized) {
        setKeyValuePairToLS(
          EDITOR_LS_CONSTANTS.CREATIVES_FORMS[AvailablePlatformsEnum.GOOGLE_ADS],
          JSON.stringify(values)
        );
      }
    },
    [isFormInitialized]
  );

  console.log(creativeType);

  const renderSwitch = (): JSX.Element => {
    switch (creativeType) {
      default:
        return <div></div>;
      case CreativeTypesEnum.SINGLE:
        const initialValues =
          creativeFormValues ||
          (initialValuesFromStore[AvailablePlatformsEnum.GOOGLE_ADS][
            CreativeTypesEnum.SINGLE
          ] as ISingleCreativeFormValuesModel);

        return (
          <Grid container spacing={2} p={2}>
            <Grid item xs={12} md={6}>
              <GoogleCreativeForm
                initialValues={initialValues}
                platform={AvailablePlatformsEnum.GOOGLE_ADS}
                onValuesChange={handleFormValuesChange}
                onMediaLibraryOpen={handleMediaLibraryOpen}
                areFieldsRequired={true}
                showMediaLibraryButton={true}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ width: '100%' }}>
              <GooglePreviewContainer />
            </Grid>
            <Grid container spacing={3}>
              {updating && (
                <Grid item xs={12}>
                  <Card sx={{ boxShadow: 'none', display: 'flex', justifyContent: 'flex-end', pb: 2 }}>
                    <CommonButton
                      size="small"
                      type="button"
                      onClick={() => handleUpdate()}
                      endIcon={<SendOutlined fontSize="small" />}>
                      {t('update')}
                    </CommonButton>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Grid>
        );
    }
  };

  return <>{renderSwitch()}</>;
};
